import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  name
  address
  integrationType
  cashPadApiUserEmail
  cashPadToken
  cashPadClientName
  countryCode
  timezone
  cashPadActive
  equalogLogin
  equalogPassword
  equalogActive
  cashPadBaseUrl
`

export const getAllEstablishmentsQuery = (brandId) => {
  var debug = `
    query {
      getEstablishments(brandId: "${brandId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getEstablishments(brandId: "${brandId}") {
        ${common}
      }
    }
  `;
}


export const getEstablishmentQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getEstablishment(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getEstablishment(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}

export const bulkDeleteEstablishmentMutation = (brandId, ids) => {
  var idsString =  JSON.stringify(ids);

  var debug = `
    mutation {
      bulkDeleteEstablishment(brandId: "${brandId}", establishmentIds: ${idsString}) {
        ids
      }
    }
  `
  console.log(debug);

  return gql`
    mutation {
      bulkDeleteEstablishment(brandId: "${brandId}", establishmentIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const createEstablishmentMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
      [] );

  var debug = `
    mutation {
      addEstablishment(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
    }
  `

  console.log(debug);

  return gql`mutation {
      addEstablishment(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateEstablishmentMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate"],
      [] );

  var debug = `
    mutation {
      updateEstablishment(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
    }
  `

  console.log(debug);

  return gql`mutation {
    updateEstablishment(brandId: "${brandId}", data: ${dataString}) {
        ${common}
    }
  }
  `;
}

export const deleteEstablishmentCache = async (brandId, ids) => {
  const query = getAllEstablishmentsQuery(brandId);
  const res = await executeQueryUtil(query);
  const newData = res.data.getEstablishments.filter(item =>
      !ids.includes(item.id)
  )

  if (res) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getEstablishments: [...newData]
      },
    });
  }
}

export const addDataEstablishmentToCache = async (brandId, datas) => {
  if (!datas) {
    return
  }
  const query = getAllEstablishmentsQuery(brandId);
  const data = await executeQueryUtil(query);

  if (data) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getEstablishments: [...data.data.getEstablishments, ...datas]
      },
    });
  }
}

